import React from "react";
import OrderView from "../views/admin/main/OrderView";

const OrderAdmin: React.FC = () => {
    return <div><OrderView /></div>;
};

export default OrderAdmin;